import _ from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectItems = state => searchEntities(state, 'items', ['name', 'makeName', 'model', 'typeName', 'propertyNames']);

export const selectItemsForAssets = state => selectItems(state).map( item => ({ value: item.id, 
  label: item.name + ((item.makeName || item.model) ? ' - ' + item.makeName + ' ' + item.model : '')}))

export const selectItemById = (state, id) => {
return selectItems(state).find(p => p.id === id)};

export const selectItemNotes = (state, id) => _.get(selectItemById(state, id), ['notes'], []);

export const selectItemDocuments = (state, id) => _.get(selectItemById(state, id), ['documents'], []);

export const selectItemFaqs = (state, id) => _.get(selectItemById(state, id), ['faqs'], []);

export const selectItemFaqTypes = (state, id) => _.chain(selectItemFaqs(state, id)).map(f => f.type).uniq().value();

export const selectItemFaqCategoriesByType = (state, id, type) => {
  var itemFaqs = selectItemFaqs(state, id);
  return _.chain(itemFaqs).filter(f => f.type === type).map(q => q.issue).uniq().value();
}

export const selectItemFaqsByTypeAndCategory = (state, id, type, category) =>{
  return _.chain(selectItemFaqs(state, id)).filter(f => f.type === type && f.issue === category).value();
}

export const selectItemFaqById = (state, itemId, id) => selectItemFaqs(state, itemId).find(f => f.id === id);
